import { TriangleAlertIcon } from "lucide-react";
import { Alert, AlertTitle } from "~/components/ui/alert";

interface NoProjectsAlertProps {
  title: string;
}

export const NoProjectsAlert = ({ title }: NoProjectsAlertProps) => (
  <Alert className="border-slate-200 bg-slate-50 text-slate-700">
    <TriangleAlertIcon className="h-4 w-4" />
    <AlertTitle>{title}</AlertTitle>
  </Alert>
);
